/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// react-router-dom components
import { useLocation, NavLink } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 2 React example components
import SidenavCollapse from "examples/Sidenav/SidenavCollapse";
import { useTranslation } from "react-i18next";
// Custom styles for the Sidenav
import SidenavRoot from "examples/Sidenav/SidenavRoot";
import sidenavLogoLabel from "examples/Sidenav/styles/sidenav";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
} from "context";
import SidenavNested from "./SideNavNested";
import { LAST_PATH, CURRENT_ZONE } from "constant";
import userInfos from "../../utils/userInfos";
import { Typography } from "@mui/material";
import { FooterComponent } from "components/footer";

// function Sidenav({ color, brand, brandName, routes, user_roles, ...rest }) {
function Sidenav({ color, brand, brandName, routes, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
  const location = useLocation();
  const { t } = useTranslation("translation");
  const collapseName = location.pathname.replace("/", "");

  let textColor = "white";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  const [referenceLink, setReferenceLink] = useState("");
  const [referenceText, setReferenceText] = useState("");

  useEffect(() => {
    if (CURRENT_ZONE === "OI") {
      setReferenceLink(
        "https://www.onehealth-oi.org/formations/mallettes-pedagogiques/mallette-pedagogique-sa"
      );
      setReferenceText(t("signature_side_bar_OI"));
    } else if (CURRENT_ZONE === "SAHEL") {
      setReferenceLink(
        "https://formation-elevage-suds.cirad.fr/autres-services-et-produits/mallettes-pedagogiques-sante-animale/mallette-pedagogique-praps-sahel"
      );

      setReferenceText(t("signature_side_bar_Sahel"));
    }
  }, []);

  useEffect(() => {
    // A function that sets the mini state of the sidenav.
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    }

    /** 
     The event listener that's calling the handleMiniSidenav function when resizing the window.
    */
    window.addEventListener("resize", handleMiniSidenav);

    // Call the handleMiniSidenav function to set the state with the initial value.
    handleMiniSidenav();

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener("resize", handleMiniSidenav);
    };
  }, [dispatch, location]);

  // Render all the routes from the routes.js (All the visible items on the Sidenav)
  // const renderRoutes = routes.map(({ type, name, icon, title, noCollapse, key, href, route, role }) => {

  // console.log("ddd", userRole);
  const renderRoutes = routes.map((item) => {
    // const userRole = userInfos()?.roles ?? [];
    // ({ type, name, icon, title, noCollapse, key, href, route, role, collapse }) => {
    let returnValue;
    let isAvalaible = true;
    if (item.role.length > 0) {
      isAvalaible = item.role
        .map((el1) => ({
          // name: el1,
          // match: userRole.some((el2) => el2.roleName.toLowerCase() === el1.toLowerCase()),
          match: userInfos()?.role === el1,
        }))
        .some((x) => x.match === true);
    }
    if (item.type === "collapse" && isAvalaible) {
      returnValue = item.href ? (
        <Link
          href={item.href}
          key={item.key}
          target="_blank"
          rel="noreferrer"
          sx={{ textDecoration: "none" }}
        >
          <SidenavCollapse
            name={item.name}
            icon={item.icon}
            // active={item.key === collapseName}
            active={collapseName.includes(item.key)}
            noCollapse={item.noCollapse}
          />
        </Link>
      ) : (
        <NavLink
          key={item.key}
          to={item.route}
          onClick={() => {
            localStorage.setItem(String(LAST_PATH), item.route);
          }}
        >
          {item.collapse.length === 0 ? (
            <SidenavCollapse name={item.name} icon={item.icon} active={item.key === collapseName} />
          ) : (
            <SidenavNested route={item} active={item.key === collapseName} />
          )}
        </NavLink>
      );
    } else if (item.type === "title") {
      returnValue = (
        <MDTypography
          key={item.key}
          color={textColor}
          display="block"
          variant="caption"
          fontWeight="bold"
          textTransform="uppercase"
          pl={3}
          mt={2}
          mb={1}
          ml={1}
        >
          {item.title}
        </MDTypography>
      );
    } else if (item.type === "divider") {
      returnValue = (
        <Divider
          key={item.key}
          light={
            (!darkMode && !whiteSidenav && !transparentSidenav) ||
            (darkMode && !transparentSidenav && whiteSidenav)
          }
        />
      );
    }

    return returnValue;
  });

  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
    >
      <MDBox pt={3} pb={0} px={4} textAlign="center">
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>
        <MDBox /* component={NavLink} to="/" */ display="flex" alignItems="center">
          {brand && <MDBox component="img" src={brand} alt="Brand" width="100%" />}
          <MDBox
            width={!brandName && "100%"}
            sx={(theme) => sidenavLogoLabel(theme, { miniSidenav })}
          >
            <MDTypography component="h6" variant="button" fontWeight="medium" color={textColor}>
              {brandName}
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
      <Divider
        light={
          (!darkMode && !whiteSidenav && !transparentSidenav) ||
          (darkMode && !transparentSidenav && whiteSidenav)
        }
      />
      <List>{renderRoutes}</List>

      <MDBox p={1} mt="auto">
        <MDBox
          // p={2}
          // mt="auto"
          sx={{
            // width: 280,
            // backgroundColor: "red",
            overflow: "hidden",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Typography
            variant="h8"
            sx={{
              whiteSpace: "normal", // Ensure the text wraps
              overflow: "hidden", // Hide any overflow
              textOverflow: "ellipsis", // Optionally add ellipsis for overflowing text
              display: "-webkit-box", // Support for multiline ellipsis
              // WebkitLineClamp: 4, // Limit the number of lines
              WebkitBoxOrient: "vertical",
              fontSize: "0.7rem", //
            }} /* style={{ color: COLORS.primary }} */
          >
            {referenceText}
          </Typography>
        </MDBox>
        <MDButton
          component="a"
          // href="https://www.onehealth-oi.org/formations/mallettes-pedagogiques/mallette-pedagogique-sa"
          href={referenceLink}
          target="_blank"
          rel="noreferrer"
          variant="gradient"
          color={sidenavColor}
          fullWidth
          sx={{
            marginTop: 2,
            marginBottom: 0,
          }}
        >
          {t("site_reference")}
        </MDButton>
      </MDBox>
      <FooterComponent />
    </SidenavRoot>
  );
}

// Setting default values for the props of Sidenav
Sidenav.defaultProps = {
  color: "info",
  brand: "",
};

// Typechecking props for the Sidenav
Sidenav.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  brand: PropTypes.string,
  brandName: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  // user_roles: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Sidenav;
